import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-appraisal",
  "use": "icon-appraisal-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-appraisal\"><path d=\"M7.176 13.17l-2.738.937a1 1 0 0 1-1.324-.962l.045-2.894a1 1 0 0 0-.2-.616L1.221 7.32a1 1 0 0 1 .506-1.556l2.766-.851a1 1 0 0 0 .525-.38l1.664-2.369a1 1 0 0 1 1.636 0l1.664 2.368a1 1 0 0 0 .525.38l2.766.852a1 1 0 0 1 .506 1.556L12.04 9.635a1 1 0 0 0-.2.616l.045 2.894a1 1 0 0 1-1.324.962l-2.738-.938a1 1 0 0 0-.648 0z\" stroke=\"#303133\" fill=\"none\" stroke-opacity=\".598\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol